export const COLOR_REACTIVA = "#45B4A3"